import doctorOne from '../assets/doctor-one.jpg';
import doctorTwo from '../assets/doctor-two.jpg';

const sliderImages = [
  {
    image: doctorOne,
  },
  {
    image: doctorTwo,
  },
];

export default sliderImages;
